import styled from 'styled-components'
import { green } from '@edulastic/colors'

export default styled.div`
  .ant-switch-checked {
    background-color: ${() => green};
  }
`
